<template>
    <div aria-live="assertive"
         class="fixed inset-0 z-50 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
        <div class="flex flex-col items-center w-full space-y-4 sm:items-end">
            <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
            <transition enter-active-class="transition duration-300 ease-out transform"
                        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                        leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
                <div v-if="show"
                     class="w-full max-w-sm overflow-hidden rounded-lg shadow-lg pointer-events-auto ring-1 ring-powder-600 ring-opacity-5 bg-powder-50">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="shrink-0">
                                <CheckCircleIcon aria-hidden="true" class="w-6 h-6 text-green-400"/>
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-semibold text-powder-950">{{ props.title }}</p>
                                <p class="mt-1 text-sm text-powder-800">{{ props.content }}</p>
                            </div>
                            <div class="flex ml-4 shrink-0">
                                <button class="inline-flex bg-white rounded-md text-clay-800 hover:text-clay-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-600" type="button"
                                        @click="show = false">
                                    <span class="sr-only">Close</span>
                                    <XMarkIcon aria-hidden="true" class="w-5 h-5"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import {CheckCircleIcon} from '@heroicons/vue/20/solid';
import {XMarkIcon} from '@heroicons/vue/20/solid';

const props = defineProps({
    title: String,
    content: String,
    show: Boolean
});
</script>